/* global Blockly */

export const secretKeyIcon = 'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M17.625%208.0625C17.625%208.99448%2016.8695%209.75%2015.9375%209.75C15.0055%209.75%2014.25%208.99448%2014.25%208.0625C14.25%207.13052%2015.0055%206.375%2015.9375%206.375C16.8695%206.375%2017.625%207.13052%2017.625%208.0625Z%22%20fill%3D%22white%22/%3E%3Cpath%20d%3D%22M3%2017.8713L10.7691%2010.1022L10.607%209.31126C10.537%208.96975%2010.5%208.61498%2010.5%208.25C10.5%205.3505%2012.8505%203%2015.75%203C18.6495%203%2021%205.3505%2021%208.25C21%209.0552%2020.8187%209.81806%2020.4948%2010.5H22.1159C22.3647%209.79625%2022.5%209.03893%2022.5%208.25C22.5%204.52208%2019.4779%201.5%2015.75%201.5C12.0221%201.5%209%204.52208%209%208.25C9%208.71673%209.04737%209.17239%209.13756%209.61244L1.5%2017.25V22.5H6.75L10.5%2018.75V16.6287L6.12868%2021H3V17.8713Z%22%20fill%3D%22white%22/%3E%3Cpath%20d%3D%22M21%2019.5C20.8665%2019.5%2020.7396%2019.5231%2020.6164%2019.5556L19.8248%2018.7642C20.0885%2018.3182%2020.25%2017.8044%2020.25%2017.25C20.25%2016.6956%2020.0885%2016.1818%2019.8248%2015.7358L20.6164%2014.9444C20.7396%2014.977%2020.8665%2015%2021%2015C21.8284%2015%2022.5%2014.3284%2022.5%2013.5C22.5%2012.6716%2021.8284%2012%2021%2012C20.1716%2012%2019.5%2012.6716%2019.5%2013.5C19.5%2013.6333%2019.5231%2013.7604%2019.5556%2013.8838L18.7642%2014.6752C18.318%2014.4115%2017.8046%2014.25%2017.25%2014.25C16.6954%2014.25%2016.1819%2014.4115%2015.7358%2014.6752L14.9444%2013.8838C14.977%2013.7603%2015%2013.6333%2015%2013.5C15%2012.6716%2014.3284%2012%2013.5%2012C12.6716%2012%2012%2012.6716%2012%2013.5C12%2014.3284%2012.6716%2015%2013.5%2015C13.6335%2015%2013.7604%2014.9769%2013.8836%2014.9444L14.6752%2015.7358C14.4115%2016.1818%2014.25%2016.6956%2014.25%2017.25C14.25%2017.8044%2014.4115%2018.3182%2014.6752%2018.7642L13.8836%2019.5556C13.7604%2019.523%2013.6335%2019.5%2013.5%2019.5C12.6716%2019.5%2012%2020.1716%2012%2021C12%2021.8284%2012.6716%2022.5%2013.5%2022.5C14.3284%2022.5%2015%2021.8284%2015%2021C15%2020.8667%2014.9769%2020.7396%2014.9444%2020.6162L15.7358%2019.8248C16.182%2020.0885%2016.6954%2020.25%2017.25%2020.25C17.8046%2020.25%2018.3181%2020.0885%2018.7642%2019.8248L19.5556%2020.6162C19.523%2020.7397%2019.5%2020.8667%2019.5%2021C19.5%2021.8284%2020.1716%2022.5%2021%2022.5C21.8284%2022.5%2022.5%2021.8284%2022.5%2021C22.5%2020.1716%2021.8284%2019.5%2021%2019.5ZM15.75%2017.25C15.75%2016.4231%2016.4229%2015.75%2017.25%2015.75C18.0771%2015.75%2018.75%2016.4231%2018.75%2017.25C18.75%2018.0769%2018.0771%2018.75%2017.25%2018.75C16.4229%2018.75%2015.75%2018.0769%2015.75%2017.25Z%22%20fill%3D%22white%22/%3E%3C/svg%3E';

function defineBlock(context) {
    const secretKeys = context.secretKeys?.length
        ? context.secretKeys.map(secretKey => [secretKey.name, secretKey.token])
        : [['- no secret keys -', '']];

    return {
        init: function () {
            this.appendDummyInput('VALUE')
                .appendField('get')
                .appendField(new Blockly.FieldImage(secretKeyIcon, 30, 30, 'Secret Key', null), 'ICON')
                .appendField(new Blockly.FieldDropdownSearch(secretKeys, undefined, '- select -'), 'SECRETKEY')
                .appendField('value');
            this.setColour(Blockly.Msg.CONNECTIONS_HUE);
            this.setPreviousStatement(false);
            this.setNextStatement(false);
            this.setOutput(true, "String");
            this.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND);
            this.setTooltip('Get the value of a Secret Key');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#connections`);
        },

        onchange: function() {
            const iconField = this.getField('ICON');
            if (iconField && iconField.imageElement_) {
                iconField.setTooltip('Secret Key');
            }

            // detect any parent block that can work with secret keys
            let currentBlock = this;
            let previousBlock = currentBlock;
            let secretKeysWillWork = false;
            while (!!currentBlock) {
                if (currentBlock.canHaveSecretKeys) {
                    // we are inside supported blocks, let's make sure we are not inside "success"/"error" statements
                    const insideStatement = currentBlock.inputList.some(input =>
                        (input.name === 'ERROR' || input.name === 'SUCCESS') &&
                        input.connection && input.connection.targetBlock() === previousBlock);
                    if (!insideStatement) {
                        secretKeysWillWork = true;
                    }
                    break;
                }
                previousBlock = currentBlock;
                currentBlock = currentBlock.parentBlock_;
            }
            if (secretKeysWillWork) {
                this.setWarningText(false);  
            } else {
                this.setWarningText('Secret Keys can only be used in non-deprecated REST blocks and when the proxy is used');
            }
        },

        onLoad: function() {
            // check that key still exists in the list
            const secretKeyId = this.getFieldValue('SECRETKEY');
            const exists = !!context.secretKeys?.some(secretKey => {
                return secretKey.token === secretKeyId;
            });
            if (exists) {
                return;
            }
            
            // reset to 'select' and show error
            const secretKeyField = this.getField('SECRETKEY');
            secretKeyField.setToSelectOption();
            secretKeyField.setWarning(true);

            // remove error when secret key is reselected
            const closure = secretKeyField.onChange;
            secretKeyField.setOnChange(function() {
                if (context.secretKeys?.length > 0) {
                    secretKeyField.setWarning(false);
                } else {
                    // when there are no keys, it should have permanent warning
                    secretKeyField.hasBeenSet = false;
                }
                if (closure) {
                    closure();
                    secretKeyField.setOnChange(closure);
                }
            });
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            const secretKeyToken = block.getFieldValue('SECRETKEY');
            const code = `"%${secretKeyToken.toLowerCase()}%"`;
            return [code, Blockly.JavaScript.ORDER_NONE];
        }
    }
}

const GetSecretKeyValue = function (props) {
    const name = 'snap_get_secret_key_value';
    GetSecretKeyValue.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);

    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (!props.context.secretKeys?.length) {
        return null;
    }

    return <block type={name}></block>;
}

export default GetSecretKeyValue;
